export const stringMapDefault = {
    activateEditor: "Click or press Enter to start editing. Press Escape to toggle focus between the toolbar and the editor.",
    characterCount: "{characterCount} of {maxLength} characters",
    maxLength: "Limited to {maxLength} characters.",
    editableLabelText: "Text Editor",
    toolbarLabelText: "Text Formatting",
    richTextEditor: "Rich Text Editor",
    placeholderText: "",
    edit: "Edit",
    delete: "Delete",
    top: "Top",
    bottom: "Bottom",
    middle: "Middle",
    normal: "Normal",
    left: "Left",
    right: "Right",
    center: "Center",
    inline: "Inline",
    baseline: "Baseline",
    insertImageFromUrl: "Insert image from URL",
    imageUrl: "Image URL",
    cancel: "Cancel",
    insert: "Insert",
    editImage: "Edit Image",
    deleteImage: "Delete",
    alignHorizontal: "Align Horizontal",
    alignVertical: "Align Vertical",
    width: "Width",
    height: "Height",
    basicTab: "Basic",
    advancedTab: "Advanced",
    upload: "Upload",
    apply: "Apply",
    alternativeText: "Alternative Text",
    alternativeTextHelpPopover: "Describe the image for a screen reader user",
    hyperlink: "Add Link",
    hyperlinkPlaceholder: "Enter a URL",
    openInNewTab: "Open in a new tab",
    lockAspectRatio: "Lock aspect ratio",
    unlockAspectRatio: "Unlock aspect ratio",
    lockMargin: "Lock margin",
    unlockMargin: "Unlock margin",
    borderRadius: "Border radius",
    close: "Close",
    margin: "Margin",
    marginTop: "Top",
    marginLeft: "Left",
    marginRight: "Right",
    marginBottom: "Bottom",
    loadingImage: "Loading image",
    uploadImageMenuLabel: "Upload Image",
    insertImageFromUrlMenuLabel: "Insert from URL",
    browseImageMenuLabel: "Browse Images",
    updateLink: "Update Link",
    editLink: "Edit Link",
    visitLinkHref: "Visit {href}",
    visitLink: "Visit Link",
    removeLink: "Remove Link",
    addLink: "Add Link",
    linkText: "Text",
    linkHref: "URL",
    add: "Add",
    update: "Update",
    clear: "Clear",
    controlLabelTypeStyle: "Text Block Style",
    controlLabelColor: "Font Color",
    controlLabelFontFamily: "Font Family",
    controlLabelFontSize: "Font Size",
    controlLabelBold: "Bold ({metaKey} + B)",
    controlLabelItalic: "Italic ({metaKey} + I)",
    controlLabelUnderline: "Underline ({metaKey} + U)",
    controlLabelAlignLeft: "Align left ({metaKey} + Shift + L)",
    controlLabelAlignCenter: "Align center ({metaKey} + Shift + E)",
    controlLabelAlignRight: "Align right ({metaKey} + Shift + R)",
    controlLabelOrderedList: "Ordered list ({metaKey} + Shift + 7)",
    controlLabelUnorderedList: "Unordered list ({metaKey} + Shift + 8)",
    controlLabelOutdent: "Outdent List  ({metaKey} + [)", // Should update these to use HTML and properly announce
    controlLabelIndent: "Indent List ({metaKey} + ])",
    controlLabelImage: "Insert Image",
    controlLabelLink: "Insert Link",
    controlLabelClearFormatting: "Clear Formatting",
    controlLabelRedo: "Redo",
    controlLabelUndo: "Undo",
    controlLabelTable: "Table",
    headingOne: "Heading 1",
    headingTwo: "Heading 2",
    headingThree: "Heading 3",
    headingFour: "Heading 4",
    headingFive: "Heading 5",
    headingSix: "Heading 6",
    paragraph: "Paragraph",
    quote: "Quote",
    resetToDefault: "Reset",
    tableColumns: "Column",
    tableColumnInsertBefore: "Insert Column Before",
    tableColumnInsertAfter: "Insert Column After",
    tableColumnDelete: "Delete Column",
    tableRows: "Row",
    tableRowInsertAbove: "Insert Row Above",
    tableRowInsertBelow: "Insert Row Below",
    tableRowDelete: "Delete Row",
    tableDelete: "Delete Table",
    tableInsert: "Insert Table"
};
